// react
import React, { useContext, useRef } from 'react';

// styles
import css from './Priorities.module.scss';

// next image
import Image from 'next/image';

// framer-motion
import { useScroll, useTransform, motion, useSpring } from 'framer-motion';

// classNames
import classNames from 'classnames';

// components
import T from '../../../common/components/T';

// utils
import { getDescriptionComponent, getTitleComponent } from './utils';
import { useWindowDimensions } from '../../../common/utils/windowDimensions';
import UserContext from '../../../common/utils/getContext';

// component
const Item = (props) => {
    const { userToken } = useContext(UserContext);
    // props
    const { opacity, index } = props;
    const width = useWindowDimensions(0);
    const desctopLg = width >= 1400;

    const blockOpacity = width < 1024 ? 1 : opacity[index];

    const blockRef = useRef();

    return (
        <div className={css.itemWrapper}>
            <motion.div className={classNames(css.itemDecor)}>
                <Image src='/src/landing/carousel/slider-bg-decor.svg' alt={'slider decor'} fill />
            </motion.div>
            <div ref={blockRef} className={css.item}>
                <motion.div style={{ opacity: blockOpacity }} className={css.itemContent}>
                    {width < 1024 ? (
                        <div className={css.mobileElements}>
                            <div className={css.mobileElementsItem}>
                                <motion.div className={classNames(css.carouselWrapperDecor)}>
                                    <Image src='/src/landing/carousel/slider-bg-decor_mob.svg' alt={'slider decor'} fill />
                                </motion.div>
                                <div className={classNames(css.textWrapper, index === '1' && css.textWrapperCentral)}>
                                    {getTitleComponent(index)}
                                </div>
                                <div className={css.descriptionWrapper}>
                                    {getDescriptionComponent(index, desctopLg, userToken)}
                                </div>
                                <div className={css.mobileImageWrapper}>
                                    <Image src={`/src/landing/carousel/carousel${+index + 1}.png`} alt={'carousel1-image'} fill />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className={css.textWrapper}>
                                <motion.div className={css.itemLightTitleWrapper} style={{ opacity: opacity[index] }}>
                                    <h3 className={css.itemLightTitle}>
                                        <T textName={'landing-main_globaltrend_text'} defaultStr={'Global Trend'} page='/' />
                                    </h3>
                                </motion.div>
                                {getTitleComponent(index)}
                            </div>
                            <div className={css.descriptionWrapper}>{getDescriptionComponent(index, desctopLg, userToken)}</div>
                        </>
                    )}
                </motion.div>
                <motion.div style={{ opacity: blockOpacity }} className={css.itemImage}>
                    <Image fill alt='Priority' src={`/src/landing/carousel/carousel${+index + 1}.png`} />
                </motion.div>
            </div>
        </div>
    );
};

const Priorities = ({ rightScrolled }) => {
    const sectionRef = useRef();

    const { scrollYProgress } = useScroll({
        target: sectionRef
    });
    const opacity = {
        0: useSpring(useTransform(scrollYProgress, [0, 0.5], [1, 0])),
        1: useSpring(useTransform(scrollYProgress, [0, 0.5], [0, 1])),
        2: useSpring(useTransform(scrollYProgress, [0.66, 0.85], [0, 1]))
    };

    return (
        <div ref={sectionRef} className={css.wrapper}>
            {rightScrolled ? (
                <>
                    <Item opacity={opacity} index={'0'} />
                    <Item opacity={opacity} index={'1'} />
                    <Item opacity={opacity} index={'2'} />
                </>
            ) : null}
        </div>
    );
};
export default Priorities;
